import { listOfGroupsPrefix } from 'mk2/apps/groups/urls';
import { ID_RE, SLUG_LEGACY_RE, USERNAME } from 'mk2/helpers/urls';

const POST_ID = `:postId(${ID_RE})`;
const IMAGE_ID = `:imageId(${ID_RE})`;
const ENTITY_ID = `:entityId(${ID_RE})`;
const ARTICLE_SLUG = `:articleSlug(${SLUG_LEGACY_RE})`;
const POST_SLUG = `:postSlug(${SLUG_LEGACY_RE})`;

export const blogsUrl = `/blogs/`;
export const blogsProfileUrl = `/blog/${USERNAME}/`;
export const blogsShortMessageUrl = `/blog/${USERNAME}/message-new/${POST_SLUG}/`;
export const blogsShortMessageEditUrl = `/blog/message-new/${POST_ID}/edit/`;
export const blogsShortMessagePhotoUrl = `/blog/${USERNAME}/message-new/${POST_SLUG}/${IMAGE_ID}/`;
export const blogsEntityLikersUrl = `/blog/likers/:type(short-message|album|article|comment)/${ENTITY_ID}/`;

export const blogsArticleCreateUrl = `/blog/${USERNAME}/article/create/`;
export const blogsArticleEditUrl = `/blog/${USERNAME}/article/${ARTICLE_SLUG}/edit/`;
export const blogsArticleUrl = `/blog/${USERNAME}/article/${ARTICLE_SLUG}/`;

// will be removed after a switch to new ListOfGroups (in forum app)
export const groupsListUrl = `${listOfGroupsPrefix}/:type(public|private)/:category?/`;
